import useAnchorClickMessageDispatcher from '@carvana/merch-native/useAnchorClickMessageDispatcher';
import { useEffect } from 'react';
import useMicroFrontend from '~/components/common/MicroFrontEnds';
import { isNonProd } from '~/constants/environment';
import ErrorWithContext from '~/utilities/ErrorWithContext';
import { logError } from '~/utilities/loggers';

/** Shared functionality for app router error pages */
export default function useErrorPage(
  page: string,
  error?: Error & { digest?: string }
) {
  useMicroFrontend(false);

  useAnchorClickMessageDispatcher({
    logError,
    source: 'error-page',
    verboseLogs: isNonProd
  });

  useEffect(() => {
    logError(
      new ErrorWithContext(error, {
        location: `${page} App Router Error Boundary`,
        digest: error?.digest
      })
    );
  }, [error, page]);
}
